import api from "api";

export function getActivityTrackingFilters() {
  return api.get("/activity-tracking/filters");
}

export function getActivitySummary(params) {
  return api.get("/user/activity-summary", { params });
}
